import { styled } from '@/stitches.config';

import { Box, Input } from '@base-app';
import { ReactComponent as CalendarIcon } from '@assets/icons/calendar.svg';
import { ReactComponent as ErrorIcon } from '@assets/icons/error.svg';

export const StyledEditContentTable = styled(Box, {
  border: '$borderWidths$1 solid $seafoam400',
  borderRadius: '$radii$4',
});

export const StyledTitleContainer = styled(Box, {
  backgroundColor: '$seafoam800',
  borderBottom: '$borderWidths$1 solid $seafoam400',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '$3 $8',
});

export const StyledContentContainer = styled(Box, {
  padding: '$3 $8',
  maxHeight: '400px',
  overflowY: 'auto',
});

export const StyledContent = styled(Box, {
  display: 'flex',
  padding: '$3 0',
  '& + &': {
    borderTop: '$borderWidths$1 solid $gray200',
  },
});

export const StyledEditedRow = styled(Box, {
  display: 'flex',
  whiteSpace: 'pre',
});

export const StyledTitle = styled(Box, {
  color: '$charcoal300',
  fontSize: '$md',
  fontWeight: '$bold',
  lineHeight: '$6',
});

export const StyledEditButton = styled(Box, {
  color: '%darkBlue100',
  cursor: 'pointer',
  fontSize: '$sm',
  fontWeight: '$medium',
  lineHeight: '$6',
});

export const StyledRow = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
});

export const StyledRowTitle = styled(Box, {
  color: '$charcoal300',
  fontSize: '$sm',
  fontWeight: '$medium',
  lineHeight: '$6',
  whiteSpace: 'pre',
});

export const StyleRowData = styled(Box, {
  color: '$darkBlue300',
  fontSize: '$md',
  fontWeight: '$bold',
  lineHeight: '$6',
});

export const StyledInput = styled(Input, {
  input: {
    paddingLeft: '$2',
  },
  '::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
  },
});

export const StyledCalendarIcon = styled(CalendarIcon, {
  cursor: 'pointer',
});

export const StyledErrorContainer = styled(Box, {
  alignItems: 'center',
  background: '$red800',
  borderRadius: '$radii$3',
  display: 'flex',
  fontSize: '$md',
  fontWeight: '$bold',
  lineHeight: '$5',
  margin: '$5 0',
  padding: '$4',
  width: '100%',
});

export const StyledErroIcon = styled(ErrorIcon, {
  color: '$red300',
});

export const StyledButtonContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '157px',
  marginTop: '$4',
});

export const StyledAddRowContainer = styled(Box, {
  marginTop: '$4',
  paddingTop: '$4',
  borderTop: '$borderWidths$1 solid $gray200',
});

export const StyledDeleteLink = styled(Box, {
  background: 'none',
  border: 'none',
  color: '$red400',
  cursor: 'pointer',
  fontSize: '$sm',
  fontWeight: '$medium',
  marginLeft: '$4',
  padding: 0,
  whiteSpace: 'nowrap',
  alignSelf: 'center',
  '&:hover': {
    textDecoration: 'underline',
  },
  '&:focus': {
    outline: '2px solid $blue400',
    outlineOffset: '2px',
  },
});
